<template>
  <div class="nav">
    <div class="nav-img">
      <img src="../img/line.webp" alt="" class="line-img" />
      <img src="../img/people.png" alt="" class="people-img" />
    </div>
    <div class="nav-text">
      <h1>{{ $t("navigation.banner.ai.empower") }}</h1>
      <div class="nav-items">
        <div class="nav-item" v-for="(item, index) in navItems" :key="index">
          <i>·</i>
          <span>{{ $t(item.label) }}</span>
        </div>
      </div>
      <el-button size="small" type="primary" @click="handleJoin">{{ $t("navigation.banner.experience.now") }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationBanner",
  data() {
    return {
      navItems: [
        {label:"navigation.banner.zero.tech.threshold"},
        {label:"navigation.banner.price.autonomy"},
        {label:"navigation.banner.permanent.profit.sharing"},
        {label:"navigation.banner.saas.entrepreneurship"},
      ],
    };
  },
  methods: {
    handleJoin() {
      // 直接调用HeaderTop组件中的openPartnerUrl方法
      this.$bus.$emit('openPartnerUrl');
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: relative;
  width: 100vw; // 使用视口宽度
  height: 340px;
  left: 50%;
  transform: translateX(-50%); // 居中显示
  margin-left: 0;
  margin-right: 0;

  .nav-img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .line-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: 1;
    }

    .people-img {
      position: absolute;
      height: 100%;
      object-fit: cover;
      object-position: center;
      z-index: 2;
      transform: translateX(68%);
    }

    // 小屏幕媒体查询，隐藏超出部分
    @media (max-width: 768px) {
      .line-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        z-index: 1;
      }

      .people-img {
        position: absolute;
        height: 64%;
        object-fit: cover;
        object-position: center;
        z-index: 2;
        transform: translateX(6%) translateY(40%);
      }
    }
  }
  .nav-text {
    position: absolute;
    top: 18%;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 1200px; // 设置最大宽度
    margin: auto;
    z-index: 3; // 确保文本在两个图片上方
    color: #0e2a5e;

    h1 {
      margin-bottom: 20px;
      font-size: clamp(24px, 4vw, 36px);
    }

    .nav-items {
      width: 100%;
      max-width: 600px;
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      margin: 20px 0px;
      .nav-item {
        span {
          margin-left: 10px;
        }
      }
    }

    ::v-deep .el-button--primary {
      background-color: #0e2a5e;
      border-color: #0e2a5e;
    }
  }
}
</style>
